import * as z from "zod/v4";
import type { util } from "zod/v4/core";

type EnumConstraint =
  | {
      enumName: string;
      isPartial: boolean;
      originalEnum: readonly string[] | util.EnumLike;
    }
  | {
      enumName?: undefined;
      isPartial?: undefined;
      originalEnum?: undefined;
    };

function _createEnum<const T extends readonly string[]>(
  values: T,
  params?: z.core.$ZodEnumParams & ({ enumName?: string } | EnumConstraint),
): z.ZodEnum<util.ToEnum<T[number]>>;
function _createEnum<const T extends util.EnumLike>(
  values: T,
  params?: z.core.$ZodEnumParams & ({ enumName?: string } | EnumConstraint),
): z.ZodEnum<T>;
function _createEnum<const T extends readonly string[]>(
  values: T,
  params?: z.core.$ZodEnumParams & ({ enumName?: string } | EnumConstraint),
): z.ZodEnum<util.ToEnum<T[number]>> {
  const schema = z.enum(values, {
    // Don't need to print expected values, included in another part of the error message
    error: (iss) => {
      const input = iss.input === "" ? "<empty-string>" : String(iss.input);
      return `Received ${input}`;
    },
  });

  if (params) {
    const metadata: Record<string, any> = {};
    if ("isPartial" in params && params.isPartial) {
      metadata.constrainedTo = values;
    }
    if (params.enumName) {
      metadata.enumName = params.enumName;
    }
    return schema.meta(metadata);
  }

  return schema;
}

export const createEnum = _createEnum;
